// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1be30502","455":"d8380aca","488":"b7e8173d"}[chunkId] + ".chunk.js";
};